import { Link, useLoaderData } from 'react-router-dom';
import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import type { PlaceNotificationsLoaderType } from './queries';
import type { IPlaceNotification } from './types';

import { usePlaceNotificationsQuery } from './queries';
import { usePagination } from '@/hooks/usePagination';
import { useColumns } from './useColumns';
import { routes } from '@/app/router/routes';

import { PageHeader } from '@/ui/PageHeader';

export const PlaceNotifications = () => {
  const { t } = useTranslation();
  const initialData = useLoaderData() as PlaceNotificationsLoaderType;
  const { data: placeNotifications, isLoading } = usePlaceNotificationsQuery(initialData);

  return (
    <>
      <PageHeader
        title={t('placeNotifications.title')}
        description={t('placeNotifications.description')}
        extra={
          <Link to={routes.placeNotificationCreate()}>
            <Button type='primary'>{t('placeNotifications.createButtonText')}</Button>
          </Link>
        }
      />
      <Table<IPlaceNotification>
        rowKey='id'
        dataSource={placeNotifications.data ?? []}
        loading={isLoading}
        columns={useColumns()}
        pagination={usePagination(placeNotifications.total, placeNotifications.per_page)}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};
